/**
 * String values returned by backend APIs in `errorCode` (and related fields).
 * Reference these from the frontend instead of scattering string literals.
 */
const API_ERROR_CODES = {
  ONLY_MESSAGE: "ONLY_MESSAGE",
};

export default API_ERROR_CODES;
